<template>
  <div :class="['location-autocomplete field-group', {'field-error':!!error}]">
    <div style="display:none;">
      <input type="text">
      <input type="password">
    </div>
    <input type="text" ref="input" autocomplete="disabled" v-model="keyInput"
      :name="extra.field" :readonly="readOnly" :placeholder="extra.placeholder"
      :disabled="disabled || locationLoading" v-if="isIosDevice"
      @keypress="query" @blur="onBlur" @focus="onFocus" @keydown.tab="onpressTab"
      v-on:blur="clickOut" @click="onClick"
      :class="['location-input field-text', {'loading':locationLoading, 'has-error':!!error, 'move-left':(extra.field === 'pickup' && !extraStop[leg].length && extra.hasExtraStop) || extra.field === 'extraStop'}]" />
    <input
      type="text" ref="input" autocomplete="disabled" v-model="keyInput"
      :name="extra.field" :readonly="readOnly" :placeholder="extra.placeholder"
      :disabled="disabled || locationLoading" v-else
      @keyup="query" @blur="onBlur" @focus="onFocus" @keydown.tab="onpressTab"
      v-on:blur="clickOut" @click="onClick"
      :class="['location-input field-text', {'loading':locationLoading, 'has-error':!!error, 'move-left':(extra.field === 'pickup' && !extraStop[leg].length && extra.hasExtraStop) || extra.field === 'extraStop'}]"
    />
    <span class="field-error-message">{{ error }}</span>
    <div class="add-stop" @click="toggleExtraStop(extra.field)"
      v-if="extra.field === 'pickup' && !extraStop[leg].length && !disabled && extra.hasExtraStop">
      <i class="fas fa-plus" @mouseover="extraStopHover = true" @mouseleave="extraStopHover = false"></i>
      <transition name="slide-up">
        <span v-show="extraStopHover">{{ $t('searchForm.youCanAdd') }}</span>
      </transition>
    </div>
    <div class="add-stop" @click="toggleExtraStop(extra.field)"
      v-if="extra.field === 'extraStop' && extraStop[leg].length && !disabled">
      <i class="fas fa-minus"></i>
    </div>
    <i class="fa fa-spinner fa-spin loaderx fa-2x" v-show="locationLoading"></i>
    <transition name="slide-down">
      <ul class="location-suggestions" v-show="showSuggestion">
        <li v-for="(item, index) in suggestions" @click="selectLocation(index)"
          :class="{'select-item':index === selectIndex}"
          :key="index">
          <i class="fas fa-plane"></i>
          <span>{{ `${item.iata} - ${item.airport}` }}</span>
        </li>
      </ul>
    </transition>
    <!-- <transition name="slide-down">
      <ul class="static-location" v-show="showStaticLocations && focusing && lastLoc.length">
        <li v-for="(loc, i) in lastLoc" :key="i" @click="selectLoc(loc)">
          <i class="fas fa-clock"></i> {{ loc.title }}
        </li>
      </ul>
    </transition> -->

  </div>
</template>

<script>
/* // global CONFIG */
// import moment from 'moment'
// const request = require('browser-request')
import { setTimeout } from 'timers';

const airports = require('@/data/airports')
const airportData = require('airport-data-js')

export default {
  name: 'location-input',
  props: ['value', 'extra', 'placeId', 'disabled', 'error', 'id', 'leg', 'noCommit'],
  data () {
    return {
      keyInput: this.value,
      autocomplete: '',
      geocoder: '',
      suggestions: [],
      showSuggestion: false,
      locationLoading: false,
      clickOutDelay: '',
      lastSelected: {},
      showStaticLocations: false,
      selectIndex: -1,
      windowInactive: false,
      isIosDevice: navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
      showOnLoad: true,
      focusing: false,
      readOnly: true,
      extraStopHover: false,
      isMasimo: false,
      lastLoc: [],
      keyputDelay: null,
      lastKeyInput: ''
    }
  },
  computed: {
    brandId () { return this.$store.state.brandId },
    route () { return this.$route.name },
    reservation () { return this.$store.state.reservation },
    extraStop () { return this.reservation.extraStop },
    d2d () { return this.reservation.d2d }
  },
  methods: {
    onClick () {
      this.$emit('clickFocus', this.extra.field)
      if (this.keyInput && this.keyInput.trim()) {
        // this.query()
      }
    },
    onpressTab () {
      if (this.selectIndex > -1) {
        this.selectLocation(this.selectIndex)
        this.selectIndex = -1
      }
    },
    query (event) {
      let self = this

      let controls = ['ArrowDown', 'ArrowUp', 'Enter']
      if (event && controls.indexOf(event.key) > -1) {
        switch (event.key) {
          case 'ArrowDown':
            self.selectIndex++
            break
          case 'ArrowUp':
            if (self.selectIndex > -1) { self.selectIndex-- }
            break
          case 'Enter':
            if (self.selectIndex > -1) {
              self.selectLocation(self.selectIndex)
              self.selectIndex = -1
            } else { self.$emit('submit', self.leg) }
            break
        }
        return
      }

      self.selectIndex = -1
      self.showStaticLocations = self.keyInput === ''

      if (!self.autocomplete) {
        if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
          setTimeout(function () {
            let container = document.getElementsByClassName('pac-container')[0]
            container.addEventListener('touchend', function (e) {
              e.stopImmediatePropagation()
            })
          }, 500)
        }
      }

      self.$emit('change', {
        field: self.extra.field,
        keyInput: self.keyInput || '',
        blurStop: true,
        id: self.id || 0,
        leg: self.leg
      })

      let queryText = self.keyInput
      if (!queryText) {
        self.suggestions = []
        self.showSuggestion = false
        return
      }

      self.showSuggestion = true
      let result1 = airports.filter(x => x.iata.toLowerCase().indexOf(self.keyInput.toLowerCase()) > -1)
      let result2 = airports.filter(x => x.airport.toLowerCase().indexOf(self.keyInput.toLowerCase()) > -1)
      let result = result1.concat(result2)
      result = result.splice(0, 10)
      self.suggestions = result
    },
    selectLocation (index) {
      let self = this
      let place = self.suggestions[index]

      if (self.locationLoading) { return }
      clearTimeout(this.clickOutDelay)
      self.showSuggestion = false
      self.locationLoading = true

      async function getAirportData () {
        let res = await airportData.getAirportByIata(place.iata)
        if (res.length) {
          res = res[0]
          let airportData = {
            title: `${place.iata}, ${place.airport}`,
            address1: '',
            address2: '',
            city: res.city,
            state: res.state,
            zip: '',
            country: res.country_code,
            lat: res.latitude,
            lng: res.longitude,
            code: place.iata,
            name: place.airport
          }

          self.keyInput = airportData.title
          self.lastSelected = airportData

          self.$emit('change', {
            field: self.extra.field,
            keyInput: self.keyInput || '',
            val: airportData
          })
          self.$emit('nextFocus')
          self.locationLoading = false
          if (window.gtag) { // eslint-disable-line
            let field = self.extra.field.charAt(0).toUpperCase() + self.extra.field.slice(1)
            gtag('event', `Flight Booking - ${field} Location`, { // eslint-disable-line
              // category: 'Custom',
              value: self.keyInput
            })
          }
        }
      }
      getAirportData()
    },
    clickOut () {
      let self = this
      self.clickOutDelay = setTimeout(function () {
        self.$emit('change', {
          field: self.extra.field,
          keyInput: self.keyInput || ''
        })
        self.showSuggestion = false
      }, 200)
    },
    focus () {
      let self = this
      self.$nextTick(function () { self.$refs.input.focus() })
    },
    onFocus () {
      this.focusing = true
      if (!this.keyInput) this.showStaticLocations = true
    },
    onBlur () {
      this.focusing = false
      this.showStaticLocations = false
    },
    selectLoc (data) {
      this.keyInput = data.title
      this.$emit('change', {
        field: this.extra.field,
        keyInput: data.title,
        leg: 'leg1'
      })
      let commit = this.extra.field === 'pickup' ? 'setPickup' : 'setDropoff'
      if (!this.noCommit) {
        this.$store.commit(`reservation/${commit}`, {
          leg: 'leg1',
          value: data
        })
        if (window.gtag) { // eslint-disable-line
          gtag( // eslint-disable-line
            'event',
            this.extra.field === 'pickup' ? 'Flight Booking - Pickup Location' : 'Flight Booking - Dropoff Location',
            {value: data.title}
          )
        }
      } else {
        this.$emit('locationVal', {
          field: this.extra.field,
          data: { leg: 'leg1', value: data }
        })
      }
      this.$emit('nextFocus')
    }
  },
  watch: {
    value: function (value) {
      this.keyInput = value
    },
    extra: function (value) {
      if (!value.disabled) {
        // let locationType = this.extra.field.charAt(0).toUpperCase() + this.extra.field.substr(1)
        if (Object.keys(this.lastSelected).length) {
          // this.$store.commit('reservation/set' + locationType, {
          //   leg: 'leg1',
          //   value: this.lastSelected
          // })
        }
      }
    }
  },
  mounted: function () {
    let self = this
    window.onblur = function () {
      self.windowInactive = true
    }

    setTimeout(function () {
      if (self.extra.field === 'pickup' && !self.value && !self.showOnLoad) {
        self.focus()
      }

      // for anti chrome autofill
      self.readOnly = false
      self.$nextTick(function () {
        self.readOnly = true
        self.readOnly = false
      })
    }, 500)

    // if (localStorage.getItem('lastPickupLoc')) {
    //   self.lastLoc.push(JSON.parse(localStorage.getItem('lastPickupLoc')))
    // }
    // if (localStorage.getItem('lastDropoffLoc')) {
    //   self.lastLoc.push(JSON.parse(localStorage.getItem('lastDropoffLoc')))
    // }
  }
}
</script>

<style lang="scss" scoped>
.location-input {
  webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.location-autocomplete {
  position: relative;
  width: 100%;
}

.location-suggestions {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  width: 100%;
  max-height: 150px;
  list-style: none;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0;
  margin: 0;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  z-index: 3;

  li {
    background: #f6f6f6;
    padding: 8px 10px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    border-bottom: 1px solid #bbb;
    color: #333;

    &:last-child {
      border-bottom: none;
    }
    i {
      margin-right: 5px;
      width: 20px;
      text-align: center;
    }
    span {
      font-size: 13px;
    }
    .fa-exclamation-triangle {
      color: #e2c84a;
    }
    .fa-map-marker {
      color: #ea5c5c;
    }
    &:hover,
    &.select-item {
      background: #0d79f2;
      color: #fff;

      i {
        color: #fff;
      }
    }
    &.empty {
      cursor: default;
    }
  }
}

.location-input {
  margin: 0;
  color: #333;
  line-height: inherit;
  transition: all 0.15s ease;
  width: 100%;
  position: relative;
  z-index: 1;

  &.loading {
    padding-right: 40px;
  }
  &.has-error {
    border-color: #f20d0d;
  }
  &:disabled {
    background: #eee;
  }
  &.move-left{
    width: calc(100% - 36px);
  }
}

.add-stop{
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  border:1px solid #ccc;
  background: #fff;
  cursor: pointer;
  box-shadow: -2px 0 3px rgba(0,0,0, .1);

  i{
    font-size: 18px;
    padding: 10px;
    color: #465a87;
  }
  span{
    background: #e1e1e1;
    padding: 8px;
    position: absolute;
    bottom: calc(100% + 25px);
    box-shadow: 3px 3px 3px 0px #A3A3A3;
    color: #000;
    font-weight: 600;
    width: 250px;
    left: -105px;
    border-radius: 10px;
    text-align: center;
    font-size: 14px;

    &:after {
      content: '';
      position: absolute;
      display: block;
      width: 0;
      z-index: 1;
      border-style: solid;
      border-color: #e1e1e1 transparent;
      border-width: 20px 20px 0;
      bottom: -20px;
      left: 50%;
      margin-left: -20px;
    }
  }
}

.extra-stop {
  .location-input{
    width: calc(100% - 36px);
  }
}

.error-msg {
  font-size: 12px;
  line-height: 1.6;
  color: #f20d0d;
  font-style: italic;
  display: block;
}

.loaderx {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 4;
  color: #bbb;

  &.move-left{
    right: 45px;
  }
}

.static-location {
  padding: 0;
  margin: 0;
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  list-style: none;
  width: 100%;
  z-index: 2;
  height: 140px;
  overflow: auto;

  li {
    display: block;
    background: #f6f6f6;
    border: 1px solid #cbd2dc;
    padding: 5px 10px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
    cursor: pointer;

    &:last-child {
      border-top: none;
    }
    &:hover {
      background: #0d79f2;
      color: #fff;
    }
  }
  i {
    margin-right: 5px;
  }
  .fa-fort-awesome {
    color: #f18538;
  }
  .fa-plane {
    color: #84a2bb;
  }
  .fa-map-marker-alt {
    color: #ff4d3b;
  }
  .fa-building {
    color: #91a2c7;
  }

  .fa-map {
    color: #79c41c;
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease-out;
}
.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease-out;
}
.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// AirportLocationInput.vue?d6b487a4